import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createElementBlock("div", {
    class: "forward-geocoding-container",
    style: _normalizeStyle(_ctx.cssStyles)
  }, [
    _withDirectives(_createVNode(_component_v_combobox, {
      class: _normalizeClass(['forward-geocoding-input', _ctx.locationJustUpdated ? 'geocode-success' : '', _ctx.small ? 'forward-geocoding-input-small' : '']),
      modelValue: _ctx.searchText,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        _ctx.setLocationFromSearchFeature
      ],
      items: _ctx.searchResults ? _ctx.searchResults.features : [],
      "item-title": _ctx.textForMapboxFeature,
      "bg-color": _ctx.bgColor,
      label: "Enter city or zip",
      density: _ctx.small ? 'compact' : 'default',
      "hide-details": "",
      solo: "",
      color: _ctx.accentColor,
      onInput: () => {},
      onKeydown: [
        _withKeys(_ctx.performForwardGeocodingSearch, ["enter"]),
        _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchResults = null), ["esc"]))
      ],
      "error-messages": _ctx.searchErrorMessage,
      "onClick:append": _ctx.focusCombobox,
      "onUpdate:focused": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFocusChange($event))),
      ref: "searchInput",
      menu: _ctx.menuOpen,
      "onUpdate:menu": _cache[3] || (_cache[3] = ($event: any) => (_ctx.menuOpen = $event))
    }, {
      append: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          class: "geocoding-search-icon",
          icon: "magnifying-glass",
          size: _ctx.searchOpen ? 'xl' : _ctx.buttonSize,
          color: "gray",
          onClick: _ctx.toggleSearch
        }, null, 8, ["size", "onClick"]),
        _renderSlot(_ctx.$slots, "append-icon", { class: "geocode-icon" }),
        _withDirectives(_createVNode(_component_font_awesome_icon, {
          class: "geocoding-close-icon",
          icon: "circle-xmark",
          size: _ctx.searchOpen ? 'xl' : '1x',
          color: "gray",
          onClick: _ctx.closeSearch
        }, null, 8, ["size", "onClick"]), [
          [_vShow, _ctx.searchOpen && !_ctx.stayOpen]
        ])
      ]),
      _: 3
    }, 8, ["class", "modelValue", "items", "item-title", "bg-color", "density", "color", "onUpdate:modelValue", "onKeydown", "error-messages", "onClick:append", "menu"]), [
      [_vShow, _ctx.searchOpen]
    ]),
    _withDirectives(_createVNode(_component_font_awesome_icon, {
      class: "geocoding-search-icon",
      icon: "magnifying-glass",
      size: _ctx.searchOpen ? 'xl' : _ctx.buttonSize,
      color: "gray",
      onClick: _withModifiers(_ctx.toggleSearch, ["prevent"])
    }, null, 8, ["size", "onClick"]), [
      [_vShow, !_ctx.searchOpen && !_ctx.stayOpen]
    ])
  ], 4))
}